import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "material-icons group-icon material-symbols-outlined mr-3"
}
const _hoisted_3 = {
  key: 1,
  class: "material-icons group-icon material-symbols-outlined mr-3"
}
const _hoisted_4 = { class: "inline-flex align-items-center w-full label-container" }
const _hoisted_5 = { class: "student-name" }
const _hoisted_6 = {
  key: 0,
  class: "material-icons ml-auto text-700"
}

import { onMounted, onUpdated, ref, toRefs, watch } from 'vue';
import MultiSelect from 'primevue/multiselect';

import { AttendeeDropdownOptionInterface, ExtendedDisciplineInterface } from '@/types';
import { EMIT } from '@/enum';

interface Props {
  availableAttendees: AttendeeDropdownOptionInterface[];
  selectedAttendees: AttendeeDropdownOptionInterface[];
  groupTherapy: boolean;
  wrapperClass?: string;
  showIcons?: boolean;
  blur?: () => void;
  placeholder?: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'SelectAttendees',
  props: {
    availableAttendees: {},
    selectedAttendees: {},
    groupTherapy: { type: Boolean },
    wrapperClass: { default: 'dashboard' },
    showIcons: { type: Boolean, default: true },
    blur: { type: Function, default: undefined },
    placeholder: { default: 'Select Attendees' }
  },
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const attendeesDropdown = ref<InstanceType<typeof MultiSelect> | null>(null);
const multiAttendee = ref<AttendeeDropdownOptionInterface[]>([]);
const singleAttendee = ref<AttendeeDropdownOptionInterface[]>([]);
const selectionLimit = ref<number | undefined>(undefined);
const { availableAttendees, selectedAttendees, groupTherapy, blur, wrapperClass, showIcons } = toRefs(props);

const updateAttendees = (): void => {
  if (!groupTherapy.value) {
    emit(EMIT.UPDATE, singleAttendee.value as AttendeeDropdownOptionInterface[]);
    selectionLimit.value = 1;
  } else {
    emit(EMIT.UPDATE, multiAttendee.value as AttendeeDropdownOptionInterface[]);
    const sizeArray = multiAttendee.value.map((attendee) => {
      const groupSizeArray = attendee.disciplines.map((discipline) => discipline.group_size);
      return groupSizeArray.includes(null) ? null : Math.max(...(groupSizeArray.filter(Number) as number[]));
    });

    selectionLimit.value =
      !sizeArray.length || sizeArray.includes(null) ? undefined : Math.max(...(sizeArray.filter(Number) as number[]));
  }
};

const onBlurHandler = () => {
  if (blur.value !== undefined) blur.value();
};

const canBeInGroup = (disciplines: ExtendedDisciplineInterface[]): boolean => {
  const activeDisciplines = disciplines.filter((discipline) => discipline.is_active);
  return !activeDisciplines.every((discipline) => {
    return discipline.is_group === false;
  });
};

const setAttendees = () => {
  if (groupTherapy.value) {
    multiAttendee.value = selectedAttendees.value as AttendeeDropdownOptionInterface[];
  } else {
    singleAttendee.value = selectedAttendees.value as AttendeeDropdownOptionInterface[];
  }
};

watch(groupTherapy, setAttendees);
onMounted(() => {
  setAttendees();
});
onUpdated(() => {
  setAttendees();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["attendee-selector flex align-items-center", _unref(wrapperClass)]),
    onBlur: onBlurHandler
  }, [
    (_unref(showIcons))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (Array.isArray(_unref(selectedAttendees)) && _unref(selectedAttendees).length <= 1)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, " person "))
            : (_openBlock(), _createElementBlock("span", _hoisted_3, "group"))
        ]))
      : _createCommentVNode("", true),
    (_unref(groupTherapy))
      ? (_openBlock(), _createBlock(_unref(MultiSelect), {
          key: 1,
          id: "attendees",
          ref_key: "attendeesDropdown",
          ref: attendeesDropdown,
          modelValue: multiAttendee.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((multiAttendee).value = $event)),
          class: "w-full",
          "panel-class": "new-event-attendee-select",
          "data-key": "value",
          options: _unref(availableAttendees),
          "option-label": "name",
          filter: true,
          display: "chip",
          "selection-limit": selectionLimit.value,
          placeholder: __props.placeholder,
          "show-toggle-all": false,
          onChange: updateAttendees,
          onBlur: onBlurHandler
        }, {
          option: _withCtx((attendee) => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(attendee.option.name), 1),
              (canBeInGroup(attendee.option.disciplines))
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, "group"))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "options", "selection-limit", "placeholder"]))
      : (_openBlock(), _createBlock(_unref(MultiSelect), {
          key: 2,
          id: "attendees",
          ref_key: "attendeesDropdown",
          ref: attendeesDropdown,
          modelValue: singleAttendee.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((singleAttendee).value = $event)),
          class: "w-full",
          "panel-class": "new-event-attendee-select",
          "data-key": "value",
          options: _unref(availableAttendees),
          "option-label": "name",
          filter: true,
          placeholder: __props.placeholder,
          "show-toggle-all": false,
          display: "chip",
          "selection-limit": selectionLimit.value,
          onChange: updateAttendees,
          onBlur: onBlurHandler
        }, null, 8, ["modelValue", "options", "placeholder", "selection-limit"]))
  ], 34))
}
}

})